import { mapGetters } from 'vuex'
import { some, isEmpty } from 'lodash'
import SimilarListingFiltersModel from '../Models/SimilarListingFiltersModel'

export default {
  computed: {
    ...mapGetters([
      'getSimilarFilterQueryStringVar',
      'getActiveSimilarFilters',
      'getSimilarRecordsUsed',
      'getUriWithoutOffset',
      'getIsTopLevelCategory'
    ])
  },
  methods: {
    filteringLocationManage (group, entry) {
      window.location.assign(this.filteringManage(group, entry))
    },
    filteringManage (group, entry) {
      const isFilterUsed = this.isFilterUsed(group, entry)
      return new SimilarListingFiltersModel(
        this.getUriWithoutOffset,
        this.getSimilarFilterQueryStringVar,
        this.getActiveSimilarFilters,
        this.getIsTopLevelCategory
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    },
    checkIfAllSimilarValueIdsAreUsed (group, entry) {
      const entryIds = entry.chunkValueIds
      if (!isEmpty(this.getSimilarRecordsUsed[group.similarGroupId])) {
        const similarRecordKeysUsed = Object.keys(this.getSimilarRecordsUsed[group.similarGroupId])
        return entryIds.map(key => similarRecordKeysUsed.includes(key)).every(element => element === true)
      }
      return false
    },
    isFilterUsed (group, entry) {
      if (this.isTextRangeGroup(group)) {
        return this.checkIfAllSimilarValueIdsAreUsed(group, entry)
      } else {
        return some(this.getSimilarRecordsUsed[group.similarGroupId], { similarId: entry.similarId })
      }
    },
    isTextRangeGroup (group) {
      return SimilarListingFiltersModel.isTextRangeGroup(group)
    },
    entryDisplayValue (group, entry) {
      if (this.isTextRangeGroup(group)) {
        return entry.chunkName
      }
      if (group.similarDisplayType === 'image' || group.similarDisplayType === 'hex-color') {
        return entry.similarDisplayValue
      }
      return entry.similarName
    }
  }
}
